export default function pass(state = '', action) {
  switch (action.type) {
    case 'add_pass': 
      return action.loginPass;
    default:
      return state;
  }
}